import { useEffect } from "react";

import "./footer.scss";
import { RootState } from "../../redux/store";
import { getCmsLinks } from "../../common/utils";
import { IMAGES, Env } from "../../common/constants";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import { useAppSelector } from "../../hooks/useAppSelector";

const Footer = () => {
  const dispatch = useAppDispatch();
  const { cms_links } = useAppSelector(
    (state: RootState) => state.globalcontent,
  );

  useEffect(() => {
    dispatch(getCmsLinks());
    // eslint-disable-next-line
  }, []);

  return (
    <div className="footer-section">
      <div className="footer-visit-section">
        <a target="_blank" rel="noopener noreferrer" href={Env.WEBSITE}>
          Visit databis.io
        </a>
      </div>
      <div className="footer-upper-section">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={cms_links.privacyPolicy}
        >
          Privacy Policy
        </a>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={cms_links.termsOfUse}
        >
          Terms of Use
        </a>
      </div>

      <div className="footer-lower-section">
        <a
          className="privacy-choices-link"
          target="_blank"
          rel="noopener noreferrer"
          href={cms_links.yourPrivacyChoices}
        >
          <img src={IMAGES.PrivacyChoiceIcon} alt="Your Privacy Choices" />
          Your Privacy Choices
        </a>
      </div>
    </div>
  );
};

export default Footer;
